import { useContext } from 'react';
import MetricsInspectionContext from '../../../state/context';
import { getParamKeysByMetricName } from '../../useActivityData/utils';
import { getTotalEntitiesStr } from '../../../Charts/ScatterChart/Header';
import { PRS_TABLE_MODEL } from './prs.model';
import { metricNames } from '@linearb/linjs-common';
import _ from 'lodash';
const usePRsCols = ({ data } = {}) => {
  const {
    state: { metricName }
  } = useContext(MetricsInspectionContext);

  const totalPrs = getTotalEntitiesStr(data?.total);
  const { orderByKey } = getParamKeysByMetricName(metricName);
  const ADDITIONAL_COLUMNS = {
    [metricNames.REVIEW_DEPTH]: [
      {
        dataPoint: PRS_TABLE_MODEL.COMMENT_CELL,
        name: 'COMMENTS',
        isSortedCol: false
      },
      {
        dataPoint: PRS_TABLE_MODEL.REVIEW_CELL,
        name: 'REVIEWS',
        isSortedCol: false
      }
    ]
  };

  const cols = [
    {
      dataPoint: PRS_TABLE_MODEL.TITLE_CELL,
      name: `${totalPrs} PRS`
    },
    {
      dataPoint: PRS_TABLE_MODEL.REPO_CELL,
      name: 'REPOS'
    },
    {
      dataPoint: PRS_TABLE_MODEL.ISSUER_CELL,
      name: 'ISSUER'
    },
    {
      dataPoint: PRS_TABLE_MODEL.STATE_CELL,
      name: 'STATE'
    },
    ..._.get(ADDITIONAL_COLUMNS, metricName, [
      {
        dataPoint: PRS_TABLE_MODEL.METRIC_VALUE_CELL,
        name: 'PR SIZE',
        sortPoint: orderByKey,
        isSortedCol: true
      }
    ])
  ];
  return cols;
};

export default usePRsCols;
